<template>
  <div class="modal-viewer hidden-header" :class="{'active': linkVideoAudio}">
    <div class="modal-viewer__body position-rel display-flex-center justify-content-center">
      <div class="overlay" @click="turnOffModal()"></div>
      <div class="modal-viewer__main">
        <PreviewVideo
          v-if="linkVideoAudio && checkVideo(linkVideoAudio)"
          :pathView="linkVideoAudio"
        />
        <PreviewAudioPoster
          v-else-if="linkVideoAudio && checkAudio(linkVideoAudio)"
          :pathView="linkVideoAudio"
          :autoPlay="true"
          :poster="imgThumbAudio"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
import PreviewAudioPoster from '@/components/content-files/PreviewAudioPoster.vue'
import mixinsFiles from '@/components/content-files/mixinsFiles'
import { STORE_KEY } from './../../_store/constants'

const imgThumbAudio = require(`@/assets/images/thumb-audio.png`)

export default {
  name: 'ModalViewVideoAudio',
  mixins: [ mixinsFiles ],
  components: {
    PreviewVideo,
    PreviewAudioPoster
  },
  data () {
    return {
      imgThumbAudio
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['linkVideoAudio'])
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetLinkAudioVieoViewer']),

    turnOffModal () {
      this.acSetLinkAudioVieoViewer('')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>